/* BÉBÉ ANGE — premium interactions (vanilla, ~2 KB, no dependencies) */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* INP: run non-urgent work right after the next paint, so taps feel instant */
  function afterPaint(fn) {
    requestAnimationFrame(function () { setTimeout(fn, 0); });
  }

  /* 1. Header shadow once the page scrolls */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      doc.classList.toggle('bb-scrolled', window.scrollY > 8);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* 2. Scroll reveal (IntersectionObserver, transform + opacity only) */
  function setupReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var selectors = [
      'main .shopify-section .section-title',
      'main .shopify-section h2',
      '.product-grid-item',
      '.feature-row__item',
      '.feature-row__image-wrapper',
      '.bb-trust__item',
      '[id*="__collection-list"] .grid-item',
      '[id*="featured_blog"] .grid-item',
      '.site-footer .grid-item',
      '.bb-section-head', '.bb-feature__gallery', '.bb-feature__content', '.bb-offer__inner', '.bb-offer__tier',
      '.bb-universe', '.bb-why__item', '.bb-why__card', '.bb-reviews__band > *', '.bb-reviews__cta',
      '.bb-journal__card', '.bb-faq__item', '.bb-final__media', '.bb-final__text', '.bb-guar__item', '.bbp__desc', '.bb-trust__item'
    ];
    var nodes = document.querySelectorAll(selectors.join(','));
    if (!nodes.length) return;
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    var groupIndex = new Map();
    nodes.forEach(function (el) {
      // Skip anything inside the header, slideshow or already in view (no flash above the fold)
      if (el.closest('#shopify-section-header, .slideshow, .slick-slider, #sticky-atc, .bb-bhero, .bb-trust__track')) return;
      if (el.tagName === 'H2' && el.closest('.bb-section-head, .bb-journal__card, .bb-feature__content, .bb-offer__inner, .bb-final__text, .bb-why__card')) return;
      if (el.matches('.bb-feature__gallery, .bb-universe, .bb-final__media')) el.classList.add('bb-reveal--zoom');
      if (isPhone.matches && el.closest('[id*="__featured-collection"]')) return;
      if (el.getBoundingClientRect().top < vh * 0.9) return;
      var parent = el.parentElement;
      var i = groupIndex.get(parent) || 0;
      groupIndex.set(parent, i + 1);
      el.style.setProperty('--bb-delay', Math.min(i % 4, 3) * 0.07 + 's');
      el.classList.add('bb-reveal');
      io.observe(el);
    });
    doc.classList.add('bb-anim');

    // Safety net: never leave content hidden (scroll check + timeout)
    var pending = true, raf = false;
    function sweep() {
      raf = false;
      var left = document.querySelectorAll('.bb-reveal:not(.is-in)');
      if (!left.length) { pending = false; window.removeEventListener('scroll', onSweep); return; }
      var limit = window.innerHeight * 1.05;
      left.forEach(function (el) { if (el.getBoundingClientRect().top < limit) el.classList.add('is-in'); });
    }
    function onSweep() { if (pending && !raf) { raf = true; requestAnimationFrame(sweep); } }
    window.addEventListener('scroll', onSweep, { passive: true });
    setTimeout(sweep, 1500);
  }

  /* 3. Cart count micro-interaction */
  function setupCartBump() {
    if (reduce || !('MutationObserver' in window)) return;
    document.querySelectorAll('.cart-count').forEach(function (badge) {
      var last = badge.textContent.trim();
      new MutationObserver(function () {
        var now = badge.textContent.trim();
        if (now !== last) {
          last = now;
          badge.classList.remove('bb-bump');
          void badge.offsetWidth;
          badge.classList.add('bb-bump');
        }
      }).observe(badge, { childList: true, characterData: true, subtree: true });
    });
  }

  var isPhone = window.matchMedia('(max-width: 749px)');

  /* 4. Product carousel progress + hint (phones) */
  function setupCarousel() {
    var track = document.querySelector('[id*="__featured-collection"] .grid-uniform');
    if (!track || track.children.length < 3) return;
    var bar = document.createElement('div');
    bar.className = 'bb-carousel-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span></span>';
    var hint = document.createElement('span');
    hint.className = 'bb-swipe-hint';
    hint.textContent = 'Faites glisser pour découvrir nos best-sellers →';
    track.parentNode.insertBefore(hint, track);
    track.parentNode.insertBefore(bar, track.nextSibling);
    var cta = document.createElement('div');
    cta.className = 'bb-carousel-cta';
    cta.innerHTML = '<a class="btn" href="/collections/all">Voir tous les produits</a>';
    bar.parentNode.insertBefore(cta, bar.nextSibling);
    var thumb = bar.firstChild, pending = false;
    function update() {
      pending = false;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.clientWidth / track.scrollWidth;
      thumb.style.width = Math.max(ratio * 100, 12) + '%';
      var p = max > 0 ? track.scrollLeft / max : 0;
      thumb.style.transform = 'translateX(' + (p * (1 / Math.max(ratio, .12) - 1) * 100) + '%)';
    }
    track.addEventListener('scroll', function () {
      if (!pending) { pending = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* 5. Brand story: collapse on phones with "Lire la suite" */
  function setupStory() {
    var box = document.querySelector('[id*="featured_image_text"] .feature-row__text > div');
    if (!box || box.scrollHeight < 520) return;
    box.classList.add('bb-story');
    var section = box.closest('.color-scheme') || box.parentElement;
    var bg = getComputedStyle(section).backgroundColor;
    if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') box.style.setProperty('--bb-story-bg', bg);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bb-story-toggle';
    btn.setAttribute('aria-expanded', 'false');
    var labelMore = 'Lire toute notre histoire', labelLess = 'Réduire';
    btn.innerHTML = '<span>' + labelMore + '</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    box.parentNode.insertBefore(btn, box.nextSibling);
    btn.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      box.style.maxHeight = open ? box.scrollHeight + 'px' : '';
      btn.setAttribute('aria-expanded', String(open));
      btn.firstChild.textContent = open ? labelLess : labelMore;
      if (!open) box.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* 6. Quantity breaks: tier buttons drive the real quantity input */
  function setupQuantityBreaks() {
    var box = document.querySelector('[data-bb-qb]');
    if (!box) return;
    var form = box.closest('form') || document;
    var input = form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    var tiers = box.querySelectorAll('.bb-qb__tier');
    function sync(q) {
      tiers.forEach(function (t) {
        var tq = parseInt(t.getAttribute('data-qty'), 10);
        var on = tq === 3 ? q >= 3 : q === tq;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-checked', String(on));
      });
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        var q = parseInt(t.getAttribute('data-qty'), 10);
        if (input) {
          input.value = q;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync(q);
      });
    });
    if (input) {
      ['input', 'change'].forEach(function (ev) {
        input.addEventListener(ev, function () { sync(parseInt(input.value, 10) || 1); });
      });
      // theme +/- buttons change the value without events
      form.addEventListener('click', function (e) {
        if (e.target.closest('.custom-selector-qty--minus, .custom-selector-qty--add')) {
          setTimeout(function () { sync(parseInt(input.value, 10) || 1); }, 0);
        }
      });
      sync(parseInt(input.value, 10) || 1);
    }
  }

  /* 7. Product page: honest delivery estimate (1-2 business days prep + 5-10 business days transit) */
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function setupEta() {
    if (!document.body.classList.contains('template-product')) return;
    var anchor = document.querySelector('.grid-id-block-grid_open_2 .cont-form.form-infos-1-button') || document.querySelector('.grid-id-block-grid_open_2 .cont-form');
    if (!anchor || document.querySelector('.bb-eta')) return;
    var now = new Date();
    var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
    var from = fmt.format(addBusinessDays(now, 6)), to = fmt.format(addBusinessDays(now, 12));
    var el = document.createElement('div');
    el.className = 'bb-eta';
    el.innerHTML = '<span class="bb-eta__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg></span>' +
      '<span><strong>Livraison offerte</strong> et suivie<br>Estimée entre le <strong>' + from + '</strong> et le <strong>' + to + '</strong></span>';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
  }

  /* 8. Product page: collapse very long descriptions */
  function setupDescCollapse() {
    var box = document.querySelector('[data-bbp-desc]') || document.querySelector('.template-product #tab-1 .product-description');
    if (!box) return;
    var limit = window.matchMedia('(max-width: 749px)').matches ? 640 : 820;
    if (box.scrollHeight < limit + 200) return;
    box.classList.add('bb-collapse');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'bb-collapse-btn'; btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span>Lire toute la description</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    box.parentNode.insertBefore(btn, box.nextSibling);
    btn.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      box.style.maxHeight = open ? box.scrollHeight + 'px' : '';
      btn.setAttribute('aria-expanded', String(open));
      btn.firstChild.textContent = open ? 'Réduire' : 'Lire toute la description';
      if (!open) box.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* 9. Fiche produit Bébé Ange (bb-main-product) */
  function setupProduct() {
    var root = document.querySelector('[data-bbp]');
    if (!root) return;
    var form = root.querySelector('[data-bbp-form]');
    var idInput = root.querySelector('[data-bbp-id]');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-bbp-variants]').textContent); } catch (e) {}
    var track = root.querySelector('[data-bbp-track]');
    var medias = track ? [].slice.call(track.querySelectorAll('.bbp__media')) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-bbp-thumb]'));
    var counter = root.querySelector('[data-bbp-index]');

    /* gallery: load every photo after the page (lazy images inside a horizontal slider sometimes stay blank until hover).
       INP: done in small batches while the phone is idle, never all at once. */
    function bbpEager() {
      var imgs = [];
      medias.concat(thumbs).forEach(function (m) {
        [].push.apply(imgs, [].slice.call(m.querySelectorAll('img[loading="lazy"]')));
      });
      var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 150); };
      (function batch() {
        if (!imgs.length) return;
        idle(function () {
          imgs.splice(0, 3).forEach(function (im) { im.loading = 'eager'; });
          batch();
        });
      })();
    }
    if (document.readyState === 'complete') setTimeout(bbpEager, 200);
    else window.addEventListener('load', function () { setTimeout(bbpEager, 200); });
    var desktop = window.matchMedia('(min-width: 990px)');
    var atc = root.querySelector('[data-bbp-atc]');
    var atcText = root.querySelector('[data-bbp-atc-text]');
    var bar = root.querySelector('[data-bbp-bar]');
    var barBtn = root.querySelector('[data-bbp-bar-btn]');
    var barPrice = root.querySelector('[data-bbp-bar-price]');
    var qty = form ? form.querySelector('input[name="quantity"]') : null;

    /* gallery: counter + thumbs (phone) */
    function goTo(i) {
      if (!track || !medias.length) return;
      i = (i + medias.length) % medias.length;
      track.scrollTo({ left: medias[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function currentIndex() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    root.querySelectorAll('[data-bbp-arrow]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(currentIndex() + parseInt(b.getAttribute('data-bbp-arrow'), 10)); });
    });
    if (track) {
      var t = false, lastIdx = 0;
      track.addEventListener('scroll', function () {
        if (t) return; t = true;
        requestAnimationFrame(function () {
          t = false;
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          if (i === lastIdx) return; /* INP: only touch the DOM when the photo actually changes */
          lastIdx = i;
          if (counter) counter.textContent = i + 1;
          thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
          var a = thumbs[i]; if (a) a.parentNode.scrollLeft = a.offsetLeft - 40;
        });
      }, { passive: true });
      thumbs.forEach(function (b) { b.addEventListener('click', function () { goTo(parseInt(b.getAttribute('data-bbp-thumb'), 10)); }); });
    }

    /* variants */
    var fieldsets = [].slice.call(root.querySelectorAll('[data-bbp-option]'));
    function selected() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(sel) {
      fieldsets.forEach(function (fs, oi) {
        [].slice.call(fs.querySelectorAll('input')).forEach(function (inp) {
          var test = sel.slice(); test[oi] = inp.value;
          var v = findVariant(test);
          inp.closest('.bbp__val').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function setText(el, txt) { if (!el) return; if (txt) { el.textContent = txt; el.hidden = false; } else { el.hidden = true; } }
    function update() {
      var sel = selected();
      fieldsets.forEach(function (fs, i) { var s = root.querySelector('[data-bbp-selected="' + i + '"]'); if (s) s.textContent = sel[i] || ''; });
      var v = findVariant(sel);
      if (!v) {
        if (atc) atc.disabled = true; if (atcText) atcText.textContent = 'Indisponible'; if (barBtn) barBtn.disabled = true;
        afterPaint(function () { markAvailability(sel); });
        return;
      }
      /* 1) what the shopper sees right away: price, button, stock */
      idInput.value = v.id;
      root.querySelector('[data-bbp-now]').textContent = v.price;
      setText(root.querySelector('[data-bbp-was]'), v.compare);
      setText(root.querySelector('[data-bbp-save]'), v.save);
      if (barPrice) barPrice.textContent = v.price;
      if (atc) atc.disabled = !v.available;
      if (barBtn) barBtn.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      var st = root.querySelector('[data-bbp-stock]');
      if (st) {
        if (!v.available) st.innerHTML = '<span class="bbp__dot is-out"></span>Épuisé pour le moment';
        else if (v.stock !== null && v.stock <= 10) st.innerHTML = '<span class="bbp__dot is-low"></span>Plus que <strong>' + v.stock + '</strong> en stock dans ce modèle';
        else st.innerHTML = '';
      }
      /* 2) INP: the rest waits until after the next paint */
      afterPaint(function () {
        markAvailability(sel);
        if (v.media) { var idx = medias.findIndex(function (m) { return m.getAttribute('data-media-id') == v.media; }); if (idx > -1) goTo(idx); }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      });
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selected());

    /* quantity */
    root.querySelectorAll('[data-bbp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-bbp-qty'), 10));
        qty.value = n;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* sticky bar */
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
      }).observe(atc);
      barBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }
  }

  /* 10. Product page: rotating highlights + real Judge.me review quotes */
  function setupPersuasion() {
    var reduceMotion = reduce;
    [].slice.call(document.querySelectorAll('[data-bbp-ticker],[data-bbp-rotate]')).forEach(function (rot) {
      var items = [].slice.call(rot.children);
      if (!items.length) return;
      var i = 0; items[0].classList.add('is-on');
      var delay = rot.hasAttribute('data-bbp-rotate') ? 4200 : 3500;
      if (items.length > 1 && !reduceMotion) setInterval(function () {
        if (document.hidden) return;
        items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on');
      }, delay);
    });
    var box = document.querySelector('[data-bbp-quotes]');
    if (!box) return;
    var slot = box.querySelector('[data-bbp-quote]');
    var tries = 0;
    function collect() {
      var revs = [].slice.call(document.querySelectorAll('.jdgm-rev'));
      var out = [];
      revs.forEach(function (r) {
        var score = parseFloat((r.querySelector('[data-score]') || {}).getAttribute ? r.querySelector('[data-score]').getAttribute('data-score') : '5') || 5;
        var body = r.querySelector('.jdgm-rev__body'), author = r.querySelector('.jdgm-rev__author');
        var txt = body ? body.textContent.replace(/\s+/g, ' ').trim() : '';
        var letters = txt.replace(/[^A-Za-zÀ-ÿ]/g, '');
        var upper = txt.replace(/[^A-ZÀ-Ý]/g, '').length;
        var words = txt.split(' ').length;
        var wellWritten = txt.length >= 40 && words >= 7 && /^[A-ZÀ-Ý"«]/.test(txt) &&
          (upper / Math.max(letters.length, 1)) < 0.3 && !/(.)\1{3,}/.test(txt) && !/[!?.]{3,}/.test(txt);
        if (score >= 5 && wellWritten && out.length < 8) out.push({ t: txt.length > 190 ? txt.slice(0, 187).replace(/\s+\S*$/, '') + '…' : txt, a: author ? author.textContent.trim() : '' });
      });
      return out;
    }
    function start(list) {
      var k = 0;
      function show() {
        if (document.hidden && k > 0) return;
        var q = list[k % list.length]; k++;
        slot.classList.remove('is-on');
        setTimeout(function () {
          slot.innerHTML = '<span class="bbp__quote-stars" aria-hidden="true">★★★★★</span><p>« ' + q.t.replace(/</g, '&lt;') + ' »</p>' + (q.a ? '<span class="bbp__quote-author">' + q.a.replace(/</g, '&lt;') + ' · Avis client</span>' : '');
          slot.classList.add('is-on');
        }, reduceMotion ? 0 : 250);
      }
      box.hidden = false; show();
      if (list.length > 1 && !reduceMotion) setInterval(show, 6500);
    }
    (function wait() {
      var list = collect();
      if (list.length) return start(list);
      if (++tries < 20) setTimeout(wait, 600);
    })();
  }


  /* ---- Animations premium ---- */
  function setupSnow() {
    if (reduce) return;
    var host = document.querySelector('.bb-feature');
    if (!host) return;
    var layer = document.createElement('div');
    layer.className = 'bb-snow'; layer.setAttribute('aria-hidden', 'true');
    var n = isPhone.matches ? 10 : 18;
    for (var i = 0; i < n; i++) {
      var f = document.createElement('span');
      var size = 3 + Math.random() * 5;
      f.style.cssText = 'left:' + (Math.random() * 100).toFixed(1) + '%;width:' + size.toFixed(1) + 'px;height:' + size.toFixed(1) + 'px;' +
        'animation-duration:' + (9 + Math.random() * 9).toFixed(1) + 's,' + (3 + Math.random() * 3).toFixed(1) + 's;' +
        'animation-delay:-' + (Math.random() * 15).toFixed(1) + 's,-' + (Math.random() * 3).toFixed(1) + 's;opacity:' + (0.35 + Math.random() * 0.45).toFixed(2);
      layer.appendChild(f);
    }
    host.insertBefore(layer, host.firstChild);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { layer.classList.toggle('is-paused', !e[0].isIntersecting); }).observe(host);
    }
  }

  function setupParallax() {
    if (reduce) return;
    var media = document.querySelector('.bb-bhero__media');
    if (!media) return;
    var hero = media.parentElement, ticking = false;
    function update() {
      ticking = false;
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      media.style.transform = 'translate3d(0,' + (-r.top * 0.18).toFixed(1) + 'px,0)';
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function setupCountUp() {
    if (reduce || !('IntersectionObserver' in window)) return;
    [].slice.call(document.querySelectorAll('.bb-reviews__big')).forEach(function (el) {
      var node = el.firstChild; if (!node || node.nodeType !== 3) return;
      var target = parseFloat(node.nodeValue.replace(',', '.')); if (!target) return;
      var dec = (node.nodeValue.split(/[.,]/)[1] || '').length, sep = node.nodeValue.indexOf(',') > -1 ? ',' : '.';
      var io = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return; io.disconnect();
        var t0 = performance.now(), dur = 1200;
        (function step(t) {
          var k = Math.min((t - t0) / dur, 1), v = target * (1 - Math.pow(1 - k, 3));
          node.nodeValue = v.toFixed(dec).replace('.', sep);
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }


  /* ---- Effets très premium ---- */
  function setupTitleWords() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var titles = [].slice.call(document.querySelectorAll('.bb-section-title, .bb-final__title, .bb-feature__title'));
    titles.forEach(function (t) {
      if (t.children.length || t.dataset.bbWords) return;
      var words = t.textContent.trim().split(/\s+/);
      t.dataset.bbWords = '1';
      t.setAttribute('aria-label', t.textContent.trim());
      t.innerHTML = words.map(function (w, i) {
        return '<span class="bb-w" aria-hidden="true"><span style="transition-delay:' + (i * 0.05).toFixed(2) + 's">' + w.replace(/</g, '&lt;') + '</span></span>';
      }).join(' ');
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { t.classList.add('bb-words-in'); io.disconnect(); }
      }, { threshold: 0.4 });
      io.observe(t);
    });
    doc.classList.add('bb-words');
  }

  function setupGlow() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    var sel = '.bb-feature__opt, .bb-why__item, .bb-journal__link, .bb-faq__item, .bb-offer__tier, .bb-universe, .product-grid-item';
    document.addEventListener('pointermove', function (ev) {
      var el = ev.target.closest && ev.target.closest(sel);
      if (!el) return;
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
      el.style.setProperty('--my', (ev.clientY - r.top) + 'px');
      el.classList.add('bb-glow');
    }, { passive: true });
  }

  function setupTilt() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    [].slice.call(document.querySelectorAll('.bb-final__media img, .bb-feature__slide img')).forEach(function (img) {
      var box = img.parentElement;
      box.addEventListener('pointermove', function (ev) {
        var r = box.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5;
        img.style.transform = 'perspective(800px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg) scale(1.03)';
      });
      box.addEventListener('pointerleave', function () { img.style.transform = ''; });
    });
  }

  function init() {
    setupTitleWords();
    setupGlow();
    setupTilt();
    setupSnow();
    setupParallax();
    setupCountUp();
    setupPersuasion();
    setupProduct();
    setupDescCollapse();
    setupQuantityBreaks();
    if (isPhone.matches) {
      setupCarousel();
      setupStory();
    }
    setupReveal();
    setupCartBump();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
